<template>
  <v-container fluid class="pa-4">
    <v-card class="elevation-2">
      <v-toolbar color="teal darken-2" dark dense>
        <v-icon left>diamond</v-icon>
        <v-toolbar-title>Takı Envanter Liste</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon :loading="loading" @click="loadData">
          <v-icon>refresh</v-icon>
        </v-btn>
        <v-btn flat class="inv-btn ma-0 ml-1" @click="$router.push('/admin/inventory')">
          <v-icon left>arrow_back</v-icon>
          Envantere Dön
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <!-- Filtreler -->
        <v-layout wrap align-center class="mb-3">
          <v-flex xs12 sm4 md3 class="pr-2">
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Seri No ile Ara"
              clearable
              hide-details
              @keyup.enter.native="loadData"
              @click:clear="search = ''; loadData()"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md3 class="pr-2">
            <v-combobox
              v-model="selectedStatus"
              :items="statusFilters"
              item-text="label"
              item-value="value"
              label="Durum"
              return-object
              hide-details
              @change="loadData"
            ></v-combobox>
          </v-flex>
          <v-flex xs12 sm4 md2>
            <v-btn color="teal darken-2" dark block class="inv-btn ma-0" :loading="loading" @click="loadData">
              <v-icon left small>search</v-icon>
              Ara
            </v-btn>
          </v-flex>
          <v-flex v-if="filterSize || filterWeightRounded != null || filterPurity != null" xs12 class="mt-2">
            <v-chip small color="teal" text-color="white" close @click:close="clearGroupFilter">
              {{ filterProductName ? filterProductName + ' / ' : '' }}Ölçü: {{ filterSize || '-' }} / Gram: {{ filterWeightRounded != null ? filterWeightRounded + ' gr' : '-' }} / Ayar: {{ filterPurityLabel || '-' }}
            </v-chip>
          </v-flex>
        </v-layout>

        <v-layout wrap class="inv-stats">
          <v-flex xs6 sm4 md2 class="pr-2">
            <div class="inv-stat">
              <div class="inv-stat-label">Kayıt</div>
              <div class="inv-stat-value">{{ jewelryItems.length }}</div>
            </div>
          </v-flex>
          <v-flex xs6 sm4 md3 class="pr-2">
            <div class="inv-stat inv-stat--green">
              <div class="inv-stat-label">Toplam Has</div>
              <div class="inv-stat-value">{{ jewelryTotalHas.toFixed(4) }} <span class="inv-stat-unit">gr</span></div>
            </div>
          </v-flex>
          <v-flex xs4 sm4 md2 class="pr-2">
            <div class="inv-stat inv-stat--teal">
              <div class="inv-stat-label">Envanterde</div>
              <div class="inv-stat-value">{{ inStockCount }}</div>
            </div>
          </v-flex>
          <v-flex xs4 sm4 md2 class="pr-2">
            <div class="inv-stat inv-stat--purple">
              <div class="inv-stat-label">Satıldı</div>
              <div class="inv-stat-value">{{ soldCount }}</div>
            </div>
          </v-flex>
          <v-flex xs4 sm4 md2>
            <div class="inv-stat inv-stat--red">
              <div class="inv-stat-label">Kayıp</div>
              <div class="inv-stat-value">{{ lostCount }}</div>
            </div>
          </v-flex>
        </v-layout>

        <v-data-table
          :headers="headers"
          :items="jewelryItems"
          :loading="loading"
          :rows-per-page-items="[50, 100, 500, { text: 'Tümü', value: -1 }]"
          class="elevation-0"
        >
          <template v-slot:items="props">
            <td class="px-2 jl-num">{{ props.item.serialNumber }}</td>
            <td class="px-2">{{ props.item.productName }}</td>
            <td class="px-2 jl-num">{{ props.item.weight }}</td>
            <td class="px-2">{{ props.item.purityLabel }}</td>
            <td class="px-2">{{ props.item.size }}</td>
            <td class="px-2 jl-num">{{ props.item.hasAmount.toFixed(4) }}</td>
            <td class="px-2 jl-num">{{ props.item.roundingDifferenceAmount != null ? props.item.roundingDifferenceAmount.toFixed(2) + ' TL' : '-' }}</td>
            <td class="px-2">
              <v-btn
                v-if="props.item.photoUrl"
                icon small
                @click="showPhoto(props.item)"
              >
                <v-icon small color="teal">photo</v-icon>
              </v-btn>
              <span v-else class="grey--text">-</span>
            </td>
            <td class="px-2">
              <v-btn small flat color="teal darken-2" class="inv-btn ma-0" @click="showCertificate(props.item)">
                <v-icon small left>description</v-icon>
                Sertifika
              </v-btn>
            </td>
            <td class="px-2">
              <span class="inv-chip" :class="statusChipClass(props.item.status)">{{ props.item.statusName }}</span>
            </td>
            <td class="px-2">{{ props.item.orderId || '-' }}</td>
            <td class="px-2">
              <v-btn small flat color="red darken-1" class="inv-btn ma-0" @click="confirmDelete(props.item)">
                <v-icon small left>delete</v-icon>
                Sil
              </v-btn>
            </td>
          </template>
          <template v-slot:no-data>
            <div class="inv-empty">
              <v-icon large color="grey lighten-1">diamond</v-icon>
              <div>Kayıt yok.</div>
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- Fotoğraf Dialog -->
    <v-dialog v-model="photoDialog" max-width="600">
      <v-card>
        <v-card-title class="headline teal darken-1 white--text">
          <v-icon left color="white">photo</v-icon>
          {{ photoItem ? photoItem.serialNumber : '' }}
        </v-card-title>
        <v-card-text class="pa-4 text-center">
          <v-progress-circular v-if="photoLoading" indeterminate color="teal" class="my-4"></v-progress-circular>
          <img v-else-if="photoSrc" :src="photoSrc" style="max-width: 100%; border-radius: 4px;" />
          <div v-else class="grey--text">Fotoğraf yüklenemedi.</div>
        </v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn flat @click="photoDialog = false">Kapat</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Sertifika Dialog -->
    <v-dialog v-model="certDialog" max-width="600" persistent>
      <v-card>
        <v-card-title class="headline teal darken-1 white--text">
          <v-icon left color="white">description</v-icon>
          Takı Sertifikası
        </v-card-title>
        <v-card-text class="pa-4">
          <div class="cert-preview" v-if="certItem">
            <cert-classic :item="certItem" />
          </div>
        </v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn flat @click="certDialog = false">Kapat</v-btn>
          <v-btn color="teal darken-2" dark class="inv-btn" @click="printCertificate">
            <v-icon left small>print</v-icon>
            Yazdır
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Silme Onay Dialog -->
    <v-dialog v-model="deleteDialog" max-width="400">
      <v-card>
        <v-card-title class="headline red darken-1 white--text">
          <v-icon left color="white">delete</v-icon>
          Silme Onayı
        </v-card-title>
        <v-card-text class="pa-4">
          <strong>{{ deleteItem ? deleteItem.serialNumber : '' }}</strong> seri numaralı takıyı silmek istediğinize emin misiniz?
        </v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn flat @click="deleteDialog = false">Vazgeç</v-btn>
          <v-btn color="red darken-1" dark class="inv-btn" :loading="deleting" @click="performDelete">Sil</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style scoped>
.cert-preview {
  overflow: auto;
  display: flex;
  justify-content: center;
}
.cert-preview >>> .cert-classic {
  transform-origin: top center;
  transform: scale(0.85);
}
.jl-num {
  font-family: Menlo, Consolas, monospace;
  font-size: 12.5px;
}
</style>

<script>
import Api from "@/api/baseApi";
import apiSettings from "@/api/appSettings";
import CertClassic from "@/components/certificates/CertClassic.vue";

export default {
  components: { CertClassic },
  data: () => ({
    loading: false,
    jewelryItems: [],
    jewelryTotalHas: 0,
    search: "",
    filterSize: null,
    filterWeightRounded: null,
    filterPurity: null,
    filterPurityLabel: null,
    filterProductName: null,
    selectedStatus: { label: "Envanterde", value: 0 },
    statusFilters: [
      { label: "Tümü", value: null },
      { label: "Envanterde", value: 0 },
      { label: "Satıldı", value: 1 },
      { label: "Kayıp", value: 2 },
    ],
    headers: [
      { text: "Seri No", value: "serialNumber" },
      { text: "Ürün", value: "productName" },
      { text: "Ağırlık", value: "weight" },
      { text: "Ayar", value: "purityLabel" },
      { text: "Ölçü", value: "size" },
      { text: "Has", value: "hasAmount" },
      { text: "Fark TL", value: "roundingDifferenceAmount", sortable: false },
      { text: "Foto", value: "photo", sortable: false },
      { text: "Sertifika", value: "certificate", sortable: false },
      { text: "Durum", value: "statusName" },
      { text: "Sipariş No", value: "orderId" },
      { text: "", value: "actions", sortable: false },
    ],
    photoDialog: false,
    photoItem: null,
    photoSrc: null,
    photoLoading: false,
    certDialog: false,
    certItem: null,
    deleteDialog: false,
    deleteItem: null,
    deleting: false,
    cdnUrl: "",
  }),

  computed: {
    inStockCount() {
      return this.jewelryItems.filter(i => i.status === 0).length;
    },
    soldCount() {
      return this.jewelryItems.filter(i => i.status === 1).length;
    },
    lostCount() {
      return this.jewelryItems.filter(i => i.status === 2).length;
    },
  },

  methods: {
    async loadData() {
      this.loading = true;
      try {
        const statusVal = this.selectedStatus ? this.selectedStatus.value : null;
        const [itemsRes, hasRes] = await Promise.all([
          this.$store.dispatch("inventory/getJewelryItems", {
            status: statusVal,
            search: this.search || null,
            size: this.filterSize || null,
            weightRounded: this.filterWeightRounded,
            purity: this.filterPurity,
            productName: this.filterProductName,
          }),
          this.$store.dispatch("inventory/getJewelryTotalHas", {
            status: statusVal,
            size: this.filterSize,
            weightRounded: this.filterWeightRounded,
            purity: this.filterPurity,
            productName: this.filterProductName,
          }),
        ]);
        this.jewelryItems = itemsRes;
        this.jewelryTotalHas = hasRes;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("Takı listesi yüklenemedi:", e);
      } finally {
        this.loading = false;
      }
    },

    clearGroupFilter() {
      this.filterPurity = null;
      this.filterPurityLabel = null;
      this.filterProductName = null;
      this.$router.replace({ path: "/admin/inventory/jewelry", query: {} });
    },

    applyRouteFilters() {
      const q = this.$route.query;
      this.filterSize = q.size || null;
      this.filterWeightRounded = q.weightRounded != null ? parseFloat(q.weightRounded) : null;
      this.filterPurity = q.purity != null && q.purity !== '' ? parseFloat(q.purity) : null;
      this.filterPurityLabel = q.purityLabel || null;
      this.filterProductName = q.productName || null;
    },

    getStatusColor(status) {
      if (status === 0) return "green";
      if (status === 1) return "blue";
      return "red";
    },

    statusChipClass(status) {
      const c = this.getStatusColor(status);
      if (c === "green") return "inv-chip--done";
      if (c === "blue") return "inv-chip--blue";
      return "inv-chip--red";
    },

    async showCertificate(item) {
      if (!item) return;
      this.certItem = {
        productName: item.productName,
        size: item.size,
        weight: item.weight,
        purityLabel: item.purityLabel,
        serialNumber: item.serialNumber || item.barcode,
        photoSrc: null,
      };
      this.certDialog = true;
      if (item.photoUrl) {
        try {
          const key = item.photoUrl;
          if (key.startsWith("http://") || key.startsWith("https://") || key.startsWith("//")) {
            this.certItem.photoSrc = key;
            return;
          }
          if (this.cdnUrl) {
            this.certItem.photoSrc = "https://" + this.cdnUrl + "/" + key;
            return;
          }
          const res = await Api.post("/api/upload/presigned-download-url", {
            fileKey: key,
          });
          this.certItem.photoSrc = res.data && res.data.downloadUrl ? res.data.downloadUrl : null;
        } catch (e) {
          console.error("Fotoğraf yüklenemedi:", e);
        }
      }
    },

    printCertificate() {
      if (!this.certItem) return;
      localStorage.setItem("jewelryCertificateData", JSON.stringify(this.certItem));
      window.open("/print/jewelry-certificate?template=classic", "_blank", "noopener,noreferrer");
    },

    async showPhoto(item) {
      if (!item || !item.photoUrl) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Bu üründe fotoğraf bulunmuyor.";
        return;
      }
      this.photoItem = item;
      this.photoSrc = null;
      this.photoDialog = true;
      this.photoLoading = true;
      try {
        const key = item.photoUrl;
        // Önce Public CDN URL dene (cdn.matobur.com - R2 public erişim)
        if (key.startsWith("http://") || key.startsWith("https://") || key.startsWith("//")) {
          this.photoSrc = key;
          this.photoLoading = false;
          return;
        }
        if (this.cdnUrl) {
          this.photoSrc = "https://" + this.cdnUrl + "/" + key;
          this.photoLoading = false;
          return;
        }
        // CDN yoksa presigned URL al
        const res = await Api.post("/api/upload/presigned-download-url", {
          fileKey: key,
        });
        this.photoSrc = res.data && res.data.downloadUrl ? res.data.downloadUrl : null;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("Fotoğraf yüklenemedi:", e);
      } finally {
        this.photoLoading = false;
      }
    },

    confirmDelete(item) {
      this.deleteItem = item;
      this.deleteDialog = true;
    },

    async performDelete() {
      if (!this.deleteItem) return;
      this.deleting = true;
      try {
        await this.$store.dispatch("inventory/deleteJewelryItem", this.deleteItem.id);
        this.deleteDialog = false;
        this.deleteItem = null;
        this.$store.state.dialog = true;
        this.$store.state.message = "Takı silindi.";
        await this.loadData();
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Silme hatası: " + (e.response && e.response.data && e.response.data.message ? e.response.data.message : e.message);
      } finally {
        this.deleting = false;
      }
    },
  },

  watch: {
    "$route.query": {
      handler() {
        this.applyRouteFilters();
        this.loadData();
      },
    },
  },

  async mounted() {
    this.applyRouteFilters();
    try {
      const configRes = await apiSettings.getConfig();
      if (configRes.data && configRes.data.cdnUrl) {
        this.cdnUrl = configRes.data.cdnUrl;
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn("CDN config alınamadı:", e);
    }
    await this.loadData();
  },
};
</script>
